import * as React from 'react';
import { SVGProps } from 'react';

const IconDinosaurSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5 2H13v1h-1v7h-2v1H8v1H7v1H4v-2H3V9H2v6h1v1h1v1h1v1h2v4h3v-1H9v-2h1v-1h1v1h1v3h3v-1h-1v-4h1v-3h1v-2h2v1h1v-2h-3V9h3V8h-2V7h5V3h-1.5V2zM16 4h-1v1h1V4z"
    />
  </svg>
);
export default IconDinosaurSizeM;
